import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ReactSpinner from 'react16-spinjs';
import Button from 'components/Button/Button';
import classes from './CalendarAuth.module.scss';

const ButtonGenerator = (props) => {
  const buttonStyle = {
    minWidth: 233,
    padding: '0 10px',
    height: 23,
    lineHeight: '23px',
    fontSize: '14px'
  };

  const {
    authorize,
    isAuthorized,
    isSigningIn,
    accountName,
    calendarName,
    signout,
    icon,
    bigButton,
    dataTestTag
  } = props;

  if (bigButton) {
    const buttonTestProps = dataTestTag ? { 'data-testid': `${dataTestTag}-sync-btn` } : {};
    return (
      <div>
        <button className={classes.authedButton} onClick={authorize} {...buttonTestProps}>
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          {icon && <object className={classes.buttonIcon} data={icon} type="image/svg+xml" />}
          <div className={classes.buttonLabel}>{calendarName}</div>
        </button>
      </div>
    );
  }

  if (isAuthorized) {
    const buttonTestProps = dataTestTag ? { 'data-testid': `${dataTestTag}-signout-btn` } : {};
    return (
      <div className={classes.authedRow}>
        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        {icon && <object className={classes.icon} data={icon} type="image/svg+xml" />}
        {accountName ? (
          <div className={classes.calendarName} data-testid="accountName">
            {accountName}
          </div>
        ) : (
          <FormattedMessage id="components.calendar.unknownAuthorized" defaultMessage="Unknown user" />
        )}

        <button
          className={classes.signoutButton}
          onClick={() => {
            signout();
          }}
          {...buttonTestProps}
        >
          <FormattedMessage id="components.calendar.disconnect" defaultMessage="Disconnect" />
        </button>
      </div>
    );
  }

  if (isSigningIn) {
    const buttonTestProps = dataTestTag ? { 'data-testid': `${dataTestTag}-signing-btn` } : {};
    return (
      <Button disabled style={{ ...buttonStyle, minWidth: '240px' }} kind="primary" {...buttonTestProps}>
        <ReactSpinner
          config={{
            lines: 13,
            length: 5,
            width: 3,
            radius: 5,
            color: '#fff',
            speed: 0.7
          }}
        />
      </Button>
    );
  }

  const buttonTestProps = dataTestTag ? { 'data-testid': `${dataTestTag}-sync-btn` } : {};
  return (
    <Button
      onClick={() => {
        authorize();
      }}
      style={{ ...buttonStyle, minWidth: '240px' }}
      kind="primary"
      {...buttonTestProps}
    >
      <FormattedMessage
        id="components.calendar.authorize"
        defaultMessage="Connect {calendarName}"
        values={{
          calendarName
        }}
      />
    </Button>
  );
};

const CalendarAuth = (props) => (
  <div className={[classes.calendarContainer, props.bigButton ? classes.bigContainer : ''].join(' ')}>
    <ButtonGenerator {...props} />
  </div>
);

ButtonGenerator.propTypes = {
  authorize: PT.func,
  calendarName: PT.string,
  signout: PT.func,
  isAuthorized: PT.bool,
  isSigningIn: PT.bool,
  accountName: PT.string,
  icon: PT.string,
  intl: PT.object,
  bigButton: PT.bool,
  dataTestTag: PT.string
};

CalendarAuth.propTypes = {
  bigButton: PT.bool
};

export default CalendarAuth;
